
import { BUSINESS_UNIT_METADATA } from '../../businessunit/model/business-unit.metadata';
import { FIREARM_METADATA } from '../../firearm/model/firearm.metadata';
import { RANGER_METADATA } from '../../ranger/model/ranger.metadata';
import { ASSETS_USER_DETAILS_METADATA } from '../../userdetails/model/assets-user-details.metadata';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, TemporalType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class FirearmPoolMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('FirearmPool', {
      firearmAssetId: <PropertyMetadata> {
        name: 'firearmAssetId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      firearm: <PropertyMetadata> {
        name: 'firearm',
        type: 'Firearm',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.OneToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return FIREARM_METADATA;
        },
        byReference: true,
        unique: false
      },
      manager: <PropertyMetadata> {
        name: 'manager',
        type: 'AssetsUserDetails',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return ASSETS_USER_DETAILS_METADATA;
        },
        byReference: true,
        unique: false
      },
      members: <PropertyMetadata> {
        name: 'members',
        type: 'Ranger',
        plural: true,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToMany,
        get relationshipEntityMetadata(): EntityMetadata {
          return RANGER_METADATA;
        },
        byReference: true,
        unique: false
      },
      businessUnit: <PropertyMetadata> {
        name: 'businessUnit',
        type: 'BusinessUnit',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        relationship: false,
        get relationshipEntityMetadata(): EntityMetadata {
          return BUSINESS_UNIT_METADATA;
        },
        byReference: true,
        unique: false
      },
      createdBy: <PropertyMetadata> {
        name: 'createdBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      createdDate: <PropertyMetadata> {
        name: 'createdDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      status: <PropertyMetadata> {
        name: 'status',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      updatedBy: <PropertyMetadata> {
        name: 'updatedBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      updatedDate: <PropertyMetadata> {
        name: 'updatedDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.firearmAssetId;
    return nullIfContainsNull(result);
  }
}



